import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga y Limpia',
    desc: 'Descarga el protocolo y limpia tu despensa usando el Semáforo de Alimentos.'
  }, {
    num: '2',
    title: 'Aplica el Vacío',
    desc: "Sigue el menú del 'Vacío Bioquímico' durante 72 horas exactas."
  }, {
    num: '3',
    title: 'Siente el Cambio',
    desc: 'Observa cómo tu ropa vuelve a cerrar y tu energía regresa desde el primer día.'
  }];
  return <section className="bg-[#E8F5E2] py-20 px-4" data-id="element-109">
      <div className="max-w-[720px] mx-auto" data-id="element-110">
        <FadeIn data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-16 text-center" data-id="element-112">
            Cómo Funciona
          </h2>
        </FadeIn>

        <div className="space-y-12 relative" data-id="element-113">
          <div className="absolute left-6 md:left-8 top-0 bottom-0 w-0.5 bg-[#4A7C42]/20 hidden md:block" data-id="element-114"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-115">
              <div className="flex flex-col md:flex-row items-start gap-6 relative" data-id="element-116">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-[#2D5A27] text-white flex items-center justify-center text-xl md:text-2xl font-bold flex-shrink-0 shadow-lg z-10" data-id="element-117">
                  {step.num}
                </div>
                <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-[#4A7C42]/10 flex-1 w-full" data-id="element-118">
                  <h3 className="text-xl md:text-2xl font-bold text-[#1A1A1A] mb-3" data-id="element-119">
                    {step.title}
                  </h3>
                  <p className="text-[#5A5A5A] text-lg leading-relaxed" data-id="element-120">
                    {step.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}